import { useQuery } from '@tanstack/react-query';

import { getSystemPlansOptions } from '@cfa/pathway-fe-shared/xp';

import { useAuth } from '@/hooks/useAuth';

/**
 * Shared hook to fetch system plans (templates).
 * Used by ManagePlansTab, ReportsPlansTab, and AddTemplateModal to share
 * the TanStack Query cache and provide systemPlans for computing isReadonlySubscribed.
 */
const useSystemPlans = () => {
  const { data } = useAuth();
  const isAtLeastLeader =
    (data?.allLocationsWithAtLeastLeaderRoles.length ?? 0) > 0;

  const {
    data: systemPlans = [],
    isFetching: isFetchingSystemPlans,
    isPending: isPendingSystemPlans,
    error: systemPlansError,
  } = useQuery({
    ...getSystemPlansOptions(),
    enabled: isAtLeastLeader,
  });

  return {
    systemPlans,
    isFetchingSystemPlans,
    isPendingSystemPlans,
    systemPlansError,
  };
};

export default useSystemPlans;
